import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TransferUnitReport } from '../models/reports/transfer-unit-report';
import { RequisitionReport } from '../models/reports/requisition-report';

@Injectable({
  providedIn: 'root',
})
export class ReportProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.reportApi;

  public getTransferUnitReport(data: TransferUnitReport): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}/transfer-unit`, data, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  public getRequisitionReport(data: RequisitionReport): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}/requisition`, data, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
